"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _CivicLogo = _interopRequireDefault(require("./CivicLogo"));

var _CivicLogoInverted = _interopRequireDefault(require("./CivicLogoInverted"));

var _CivicLogoAnimated = _interopRequireDefault(require("./CivicLogoAnimated"));

var _CivicLogoAnimatedInverted = _interopRequireDefault(require("./CivicLogoAnimatedInverted"));

var _CivicLogoC = _interopRequireDefault(require("./CivicLogoC"));

var _CivicLogoCAnimated = _interopRequireDefault(require("./CivicLogoCAnimated"));

var _CivicLogoCInverted = _interopRequireDefault(require("./CivicLogoCInverted"));

var _CivicSandboxLogoInverted = _interopRequireDefault(require("./CivicSandboxLogoInverted"));

var _MasterBuilders = _interopRequireDefault(require("./MasterBuilders"));

var _HackOregonLogo = _interopRequireDefault(require("./HackOregonLogo"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function Logo(_ref) {
  var type = _ref.type,
      alt = _ref.alt,
      other = _objectWithoutProperties(_ref, ["type", "alt"]);

  switch (type) {
    case "standardLogo":
      return _react["default"].createElement(_CivicLogo["default"], {
        alt: alt
      });

    case "standardLogoInverted":
      return _react["default"].createElement(_CivicLogoInverted["default"], {
        alt: alt
      });

    case "standardLogoAnimated":
      return _react["default"].createElement(_CivicLogoAnimated["default"], {
        alt: alt
      });

    case "standardLogoAnimatedInverted":
      return _react["default"].createElement(_CivicLogoAnimatedInverted["default"], {
        alt: alt
      });

    case "squareLogo":
      return _react["default"].createElement(_CivicLogoC["default"], _extends({
        alt: alt
      }, other));

    case "squareLogoAnimated":
      return _react["default"].createElement(_CivicLogoCAnimated["default"], {
        alt: alt
      });

    case "squareLogoInverted":
      return _react["default"].createElement(_CivicLogoCInverted["default"], {
        alt: alt
      });

    case "sandboxLogoInverted":
      return _react["default"].createElement(_CivicSandboxLogoInverted["default"], {
        alt: alt
      });

    case "hackOregon":
      return _react["default"].createElement(_HackOregonLogo["default"], {
        alt: alt
      });

    case "masterBuilders":
      return _react["default"].createElement(_MasterBuilders["default"], {
        alt: alt
      });

    default:
      return _react["default"].createElement(_CivicLogoAnimated["default"], {
        alt: alt
      });
  }
}

Logo.displayName = "Logo";
Logo.propTypes = {
  type: _propTypes["default"].string,
  alt: _propTypes["default"].string
};
Logo.defaultProps = {
  type: "standardLogoAnimated",
  alt: "CIVIC Logo"
};
var _default = Logo;
exports["default"] = _default;